import React from 'react'
import { Link } from 'react-router-dom'

export default function Breadcumb(props) {
  return (
    <>
      <section className="inner_header_banner position-relative bg-[#FBF8F1] md:pt-28 pt-10 pb-10 mt-[80px]">
        <div className="pagehding text-center">

          <h2 className='text-bold mb-4'>
            {props.pagetitle}
          </h2>

          <div className='breadcrumb flex gap-4 justify-content-center tracking-wider'>

            {props.breadcrumbs ? (
              props.breadcrumbs.map((item, index) => (
                <React.Fragment key={index}>

                  {item.link ? (
                    <Link to={item.link}>{item.label}</Link>
                  ) : (
                    <span>{item.label}</span>
                  )}

                  {index !== props.breadcrumbs.length - 1 && (
                    <span>/</span>
                  )}

                </React.Fragment>
              ))
            ) : (
              <>
                <Link to="/">Home</Link>
                <span>/</span>
                <span>{props.pagetitle}</span>
              </>
            )}

          </div>

        </div>
      </section>
    </>
  )
}